import { AspectRatio, Text, VStack } from '@chakra-ui/react'

import Image from 'next/image'

const Design = () => {
  return (
    <VStack
      w="100%"
      justifyContent="center"
      alignItems="center"
      position="relative"
      h="100%"
      py={{
        base: '40px',
        sm: '60px',
        md: '80px',
        lg: '100px'
      }}
    >
      <AspectRatio
        w={{
          base: '300px',
          sm: '400px',
          md: '500px',
          lg: '700px',
          xl: '900px'
        }}
        ratio={1474 / 752}
        position="relative"
      >
        <Image
          src="https://habbit-sg.s3.ap-southeast-1.amazonaws.com/five-tumbler-1711633255192.png"
          alt="five tumbler"
          fill
        />
      </AspectRatio>

      <Text
        textStyle="gripMainTitle"
        textTransform="uppercase"
        textAlign="left"
        color="#fff"
        w={{
          base: '100%',
          sm: '400px',
          md: '500px',
          lg: '700px',
          xl: '900px'
        }}
        mt={10}
      >
        CAR CUP HOLDER FRIENDLY
      </Text>
      <Text
        textStyle="gripContentSmall"
        color="#fff"
        textAlign="left"
        w={{
          base: '100%',
          sm: '400px',
          md: '500px',
          lg: '700px',
          xl: '900px'
        }}
        mb={5}
      >
        Designed with convenience in mind, this tumbler easily fits into most
        car cup holders, ensuring you stay refreshed on the go.
      </Text>
    </VStack>
  )
}

export default Design
